<template>
  <div id="upload-dados">
    <v-container>
      <v-card
        class="py-4 px-1"
        tile
      >
        <page-title
          main="Administração"
          icon="mdi-pencil-box-outline"
          sub="Upload de dados no banco"
          home="/administracao"
        />
        <form-dados />
      </v-card>
    </v-container>
  </div>
</template>

<script>
import PageTitle from '@/components/template/PageTitle'
import FormDados from '../cadastros/dados'
export default {
  name: 'UploadDados',
  components: { PageTitle, FormDados },
  data: () => ({

  })
}
</script>
